import React from "react";
import { NavLink } from "react-router-dom";
import "../Header.css";

export default function Header() {
  return (
    <>
    {/* Social Media Navbar */}
<div className="text-dark py-2" style={{ backgroundColor: "#fffcf5" }}>
  <div className="container d-flex justify-content-between align-items-center">
    <span style={{ fontSize: "16px", fontWeight: "bold" }}>
      Call us: (+91) 8143964374 | Email: info@psritservices.com
    </span>
    <div style={{ fontSize: "16px", fontWeight: "bold" }}>
     <a
        href="https://www.linkedin.com/company/psr-it-services/"
        target="_blank"
        rel="noopener noreferrer"
        style={{
          color: "#0e76a8",
          textDecoration: "underline",
          fontWeight: "bold",
          marginLeft: "6px",
          cursor: "pointer"
        }}
        onMouseEnter={e => (e.target.style.color = "#0a58ca")}
        onMouseLeave={e => (e.target.style.color = "#0e76a8")}
      >
        LinkedIn
      </a>
    </div>
  </div>
</div>

    {/* Main Navbar */}
      <header
        className="shadow-md"
        style={{ backgroundColor: "#4a1717", padding: "11px 0" }}
      >
        <div className="container d-flex justify-content-between align-items-center">
          {/* Logo */}
          <div className="d-flex align-items-center">
            <img
              src="/images/logo.jpg"
              alt="PSR-IT Services Logo"
              className="me-3"
              style={{ height: "55px" }}
            />
          </div>

          {/* Navigation Links */}
          <nav>
            <ul className="nav">
              {["Home", "About Us", "Services", "Careers", "Contact"].map(
                (item, index) => (
                  <li className="nav-item" key={index}>
                    <NavLink
                      to={`/${item.toLowerCase().replace(/\s/g, "")}`}
                      className={({ isActive }) =>
                        isActive ? "nav-link active" : "nav-link"
                      }
                      style={{
                        textDecoration: "none",
                        fontSize: "16px",
                      }}
                    >
                      {item}
                    </NavLink>
                  </li>
                )
              )}
            </ul>
          </nav>
        </div>
      </header>
    </>
  );
}
